import * as _ from 'lodash';
import * as React from 'react';
import * as Model from '../../api/model';
import { Grid, CircularProgress, Paper, Table, TableHead, TableRow, TableCell, TableBody, Toolbar, Typography, Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { API } from '../../api';
import WineryForm from './WineryForm';
import WineryItem from './WineryItem';

//#region UI configuration
const strings = {
    title: 'Wineries',
    addButton: 'Add',
    idColumn: 'Id',
    appellationColumn: 'Appellation',
    domainColumn: 'Domain',
    classificationColumn: 'Classification',
    producerColumn: 'Producer'
};
//#endregion

//#region Props & State
interface WineriesPageProps { }
interface WineriesPageState {
    loading: boolean;
    items: Model.Winery[];
    selected: null | Model.Winery;
    add: boolean;
}

const initialState: WineriesPageState = {
    loading: true,
    items: [],
    selected: null,
    add: false
};
//#endregion

class WineriesPage extends React.Component<WineriesPageProps, WineriesPageState> {

    constructor(props: WineriesPageProps) {
        super(props);

        this.state = initialState;
    }

    // #region Lifecycle
    componentDidMount(): void {
        API.winery.list().then(items => {
            this.setState({ loading: false, items });
        });
    }

    render() {
        const { loading, items, selected, add } = this.state;

        return (
            <React.Fragment>
                {loading && <Grid container={true} justify="center">
                    <CircularProgress />
                </Grid>}

                {!loading && <Paper>
                    <Toolbar>
                        <Grid container={true} justify="space-between" alignItems="center">
                            <Grid item={true}>
                                <Typography variant="title">{strings.title}</Typography>
                            </Grid>
                            <Grid item={true}>
                                <Tooltip title={strings.addButton}>
                                    <IconButton onClick={this.onAddClick}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Toolbar>

                    <Table>
                        <colgroup>
                            <col width="5%" />
                            <col width="22%" />
                            <col width="22%" />
                            <col width="22%" />
                            <col width="22%" />
                            <col width="5%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell numeric={true}>{strings.idColumn}</TableCell>
                                <TableCell>{strings.appellationColumn}</TableCell>
                                <TableCell>{strings.domainColumn}</TableCell>
                                <TableCell>{strings.classificationColumn}</TableCell>
                                <TableCell>{strings.producerColumn}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {add && <WineryForm onItemSaved={this.onItemSaved} onCancelItemForm={this.onCancelItemForm} />}
                            {!!selected && <WineryForm onItemSaved={this.onItemSaved} onCancelItemForm={this.onCancelItemForm} item={selected} />}
                            {items.map(item => (
                                <WineryItem
                                    key={item.id}
                                    item={item}
                                    selected={selected !== null && selected.id === item.id}
                                    onItemSelected={this.onItemClick}
                                    onItemRemoved={this.onItemRemoved}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </Paper>}
            </React.Fragment>
        );
    }
    // #endregion

    // #region Private
    private onAddClick = () => {
        this.setState({ add: true });
    }

    private onItemClick = (item: Model.Winery) => {
        const { selected } = this.state;
        if (selected === null || selected.id !== item.id) {
            this.setState({ selected: item });
        } else {
            this.setState({ selected: null });
        }
    }

    private onItemRemoved = (id: number) => {
        const { items } = this.state;
        this.setState({ selected: null, items: items.filter(value => value.id !== id) });
    }

    private onItemSaved = (model: Model.Winery, isNew: boolean) => {
        let { items } = this.state;

        if (isNew) {
            items = items.concat(model);
        } else {
            items = items.map(item => {
                if (item.id === model.id) {
                    return model;
                } else {
                    return item;
                }
            });
        }

        items = _.sortBy(items, [(o: Model.Winery) => (o.domain), (o: Model.Winery) => (o.producer)]);
        this.setState({ items, add: false, selected: null });
    }

    private onCancelItemForm = () => {
        this.setState({ add: false, selected: null });
    }
    // #endregion
}

export default WineriesPage;



// WEBPACK FOOTER //
// ./src/modules/winery/WineriesPage.tsx